var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMovie = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 77,
  height: 77,
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#movie_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#2100C4",
  d: "M68.264 11.272 65.71 1.997l-4.586 1.28-2.755 1.39-3.36.317-6.115 1.71-2.349 1.161-3.766.547-6.115 1.708-2.463 1.397-3.652.312-6.115 1.707-2.392 1.666-3.723.043-13.732 3.836-.028.003.957 9.577 4.789-.479-.07-.69 15.225-4.251 2.57-1.666 3.545-.044 6.115-1.707 1.996-1.404 4.119-.305 6.115-1.707 2.735-1.462 3.38-.247 6.115-1.708 2.216-1.351z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#00CDDA",
  d: "M69.999 28.655 6.15 35.035l3.51 35.117 63.849-6.38z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#2100C4",
  d: "M69.362 22.27 5.514 28.65l.957 9.578 63.848-6.38z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#00CDDA",
  d: "m27.215 36.154-6.385.638 3.832-10.055 6.385-.638zM39.987 34.878l-6.385.638 3.831-10.055 6.385-.639zM52.758 33.602l-6.385.638 3.832-10.056 6.385-.638zM65.531 32.326l-6.384.638 3.831-10.056 6.385-.638zM62.14 12.981l6.115-1.709-7.14-7.995-6.116 1.709zM49.91 16.398l6.115-1.71-7.141-7.995-6.115 1.71zM37.687 19.814l6.115-1.71-7.14-7.994-6.116 1.709zM25.457 23.23l6.115-1.709-7.141-7.995-6.115 1.71z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#2100C4",
  d: "M6.063 34.215a5.202 5.202 0 1 0-1.035-10.353 5.202 5.202 0 0 0 1.035 10.353"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#00CDDA",
  d: "m5.033 23.862 1.035 10.352a5.202 5.202 0 0 0-1.035-10.352"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "movie_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h77v77H0z"
})))));
export default SvgMovie;